import {
  forwardRef,
  ForwardRefRenderFunction,
  useEffect,
  useImperativeHandle,
  useRef,
  useState
} from 'react';
import { Typography } from 'antd';
import dayjs from 'dayjs';
import { AudioCallStatuses } from 'constants/voip';

import { AudioCallHeaderMethods } from '../_types';
import { secondsToMMSS } from './_utils';
import { StyledCallHeader } from './styled';

interface IProps {
  status: AudioCallStatuses;
  callerName: string;
}

const CallHeader: ForwardRefRenderFunction<AudioCallHeaderMethods, IProps> = (
  { status, callerName },
  ref
) => {
  const startTime = useRef(new Date());
  const [timer, setTimer] = useState(0);

  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (status === AudioCallStatuses.connected) {
      interval = setInterval(() => {
        const diff = dayjs().diff(startTime.current, 'seconds');

        setTimer(diff);
      }, 1000);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [status]);

  const renderInfo = () => {
    switch (status) {
      case AudioCallStatuses.calling:
        return ' - calling';
      case AudioCallStatuses.connecting:
        return ' - connecting';
      case AudioCallStatuses.connected:
        return ` - ${secondsToMMSS(timer)}`;
      default:
        return null;
    }
  };

  useImperativeHandle(ref, () => ({
    setStartTime(date) {
      startTime.current = date;
    }
  }));

  return (
    <StyledCallHeader>
      <Typography.Title level={5}>MedicusUnion {renderInfo()}</Typography.Title>
      <Typography.Title level={3}>{callerName}</Typography.Title>
    </StyledCallHeader>
  );
};

export default forwardRef(CallHeader);
